// FILE: src/components/CoachSaysCard.js
//
// Accent quote card. Different voice from CoachInsight — this one frames
// the trend specifically ("You're 5 days ahead of pace" etc.) instead of
// a generic encouragement line.

import React from 'react';
import styles from './CoachSaysCard.module.css';

export default function CoachSaysCard({ readiness, trend, secondaryGuidance }) {
  const status = readiness?.status || 'not_started';
  const score  = typeof readiness?.score === 'number' ? readiness.score : null;
  const line   = pickLine({ status, score, trend });

  return (
    <div className={styles.card}>
      <div className={styles.label}>⭐ Coach Says</div>
      <div className={styles.line} dangerouslySetInnerHTML={{ __html: line }} />
      {/* Optional secondary-dimension guidance (e.g. PMOCP Focus Areas).
          Only present when getSecondaryDimension(examId) is non-null AND the
          learner has qualifying data; absent for all other certs. */}
      {secondaryGuidance?.text && (
        <div className={styles.line} data-testid="coach-says-secondary">
          {secondaryGuidance.text}
        </div>
      )}
    </div>
  );
}

function pickLine({ status, score, trend }) {
  if (status === 'not_started') return 'Set your baseline to unlock personalized coaching.';
  if (status === 'exam_ready')  return `You're at <b>${Math.round(score)}/100</b>. Book the exam — you're ready.`;
  if (trend?.sufficient && trend.direction === 'up') {
    return `You're <b>+${trend.delta} pts</b> over last week and trending upward. Great work!`;
  }
  if (trend?.sufficient && trend.direction === 'down') {
    return `Down <b>${Math.abs(trend.delta)} pts</b> this week — one targeted session turns it around.`;
  }
  if (score != null) {
    return `Steady at <b>${Math.round(score)}/100</b>. Consistency builds confidence.`;
  }
  return 'Every session adds a data point — keep going.';
}
